import {Home} from '@material-ui/icons'

import {Base} from './Base'

export class Market extends Base {
  static type = 'market'
  static typeDisplay = 'Market'
  static icon = Home

  type = Market.type
  typeDisplay = Market.typeDisplay
  icon = Market.icon

  guid: string = ''
  name: string = ''
}
